<template>
  <div class="mt-4 grid grid-rows-1 gap-4 md:grid-cols-3">
    <div class="col-span-2 grid gap-4 md:grid-cols-2">
      <LabeledText :label="t('renter')"
        >{{ booking.customerData?.firstName ?? 'n/a' }}
        {{ booking.customerData?.lastName ?? 'n/a' }}</LabeledText
      >

      <LabeledText :label="t('bookingNumber')">
        <CopyToClipboardButton :text="booking.bookingNumber" class="my-2">
          {{ booking.bookingNumber }}
        </CopyToClipboardButton>
      </LabeledText>

      <LabeledText :label="t('phoneCustomer')">
        <PhoneLink :phone-number="booking.customerData?.phone" />
      </LabeledText>
    </div>

    <div class="flex flex-col space-y-2">
      <LabeledText :label="t('customerComment')">
        {{ booking.customerComment || t('noComment') }}
      </LabeledText>
      <LabeledText :label="t('internalComment')">
        {{ booking.internalComment || t('noComment') }}
      </LabeledText>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Booking } from '@/entities/bookings/booking.entity';
import { useI18n } from 'vue-i18n';
import LabeledText from '@/components/LabeledText.vue';
import PhoneLink from '@/components/PhoneLink.vue';
import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue';

const { t } = useI18n();
defineProps<{
  booking: Booking;
}>();
</script>

<i18n lang="json">
{
  "en": {
    "customerComment": "Customer Comment",
    "internalComment": "Internal Comment",
    "returnOverview": "Return overview",
    "renter": "Renter",
    "bookingNumber": "Booking Nr.",
    "vehicle": "Vehicle",
    "startDate": "Start of rental",
    "endDate": "End of rental",
    "noComment": "No Comment",
    "phoneCustomer": "Phone Customer"
  },
  "de": {
    "customerComment": "Kundenkommentar",
    "internalComment": "Interner Kommentar",
    "returnOverview": "Buchungsübersicht",
    "renter": "Mieter",
    "bookingNumber": "Buchungs Nr.",
    "vehicle": "Fahrzeug",
    "startDate": "Mietbeginn",
    "endDate": "Mietende",
    "noComment": "Kein Kommentar",
    "phoneCustomer": "Telefon Kunde"
  },
  "es": {
    "customerComment": "Comentario del cliente",
    "internalComment": "Comentario interno",
    "returnOverview": "Vista general de la devolución",
    "renter": "Arrendatario",
    "bookingNumber": "N.º reserva",
    "vehicle": "Vehículo",
    "startDate": "Inicio del alquiler",
    "endDate": "Fin del alquiler",
    "noComment": "Sin comentario",
    "phoneCustomer": "Teléfono del cliente"
  }
}
</i18n>
